/* Передаём родителя и определяем, влезаем ли в него ребёнок */
import React from 'react';

export const checkOverflow = (element: HTMLElement): boolean => {
  return (
    element.scrollWidth > element.offsetWidth ||
    element.scrollHeight > element.offsetHeight
  );
};

/**
 * const element =
 *  `<List>
 *    <Item />
 *    <Item />
 *    <Item />
 *  </List>`
 *
 * useEffect(() => {
 *   if (checkOverflow(element)) {
 *     //не влезает
 *     do something...
 *   }
 * }, [])
 *
 * **/

/* Закрытие и снятие фокуса с react-select с префиксом select-prefix при скролле страницы */
export const onCloseScroll = (e: any) => {
  const isOutsideSelect =
    !e.target.className?.includes('MenuList') &&
    !e.target.className?.includes('menu-list') &&
    !e.target.className?.includes('select-prefix') &&
    e.target.nodeName !== '#document';

  if (isOutsideSelect) {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.className.includes('select-prefix')) {
      activeElement.blur();
    }
    return true;
  }

  return false;
};

/* Ограничение на ввод только цифр в инпуте */
/** <Input onKeyDown={(e) => handleNumberKeyCheck(e)} /> **/
export const handleNumberKeyCheck = (
  e: React.KeyboardEvent<HTMLInputElement>,
  rating?: boolean
) => {
  if (rating) {
    if (
      !['0', '1', '2', '3', '4', '5', 'Backspace', 'Delete'].includes(e.key)
    ) {
      e.preventDefault();
    }
  } else {
    if (
      ![
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        'Delete',
      ].includes(e.key)
    ) {
      e.preventDefault();
    }
  }
};

/* Ограничение на ввод только чисел в инпуте (с возможностьбю дробного значения) */
export const handleCostKeyCheck = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (
    ![
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '.',
      'Backspace',
      'Delete',
    ].includes(e.key)
  ) {
    e.preventDefault();
  }
};

/* Ограничение на ввод только букв в инпуте */
/** <Input onKeyDown={(e) => handleLetterKeyCheck(e)} /> **/
export const handleLetterKeyCheck = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (/[^a-zA-Zа-яА-ЯёЁ .]/i.test(e.key)) {
    e.preventDefault();
  }
};

/* Установка курсора в нужное место в инпуте с ReactInputMask */
export const cursorFinder = (e: any) => {
  /** <Input onFocus={(e) => cursorFinder(e)} onClick={(e) => cursorFinder(e)} /> **/
  if (e.target.value === '___-___-__-__') {
    e.target.selectionStart = 0;
    e.target.selectionEnd = 0;
  } else if (
    e.target.value.includes('_') &&
    (e.target.value.indexOf('_') < e.target.selectionStart ||
      e.target.value.indexOf('_') > e.target.selectionStart)
  ) {
    let pos = e.target.value.indexOf('_');
    e.target.selectionStart = pos;
    e.target.selectionEnd = pos;
  } else if (!e.target.value.includes('_')) {
    e.target.selectionStart = 16;
    e.target.selectionEnd = 16;
  }
};

/* Закрытие дейтпикера react-datepicker по скроллу вне него (closeOnScroll) */
export const handleCloseDatePicker = (e: any) => {
  return e.target.className !== 'react-datepicker__time-list';
};
